document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.know-your-silhouette').forEach(function (section) {
    var tabs = section.querySelectorAll('.know-your-silhouette-tab');
    var panels = section.querySelectorAll('.know-your-silhouette-panel');
    var comparisonCells = section.querySelectorAll('.know-your-silhouette-comparison-cell');
    var isAnimating = false;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        if (isAnimating) return;

        var index = this.getAttribute('data-index');
        var currentPanel = section.querySelector('.know-your-silhouette-panel.is-active');
        var nextPanel = section.querySelector('.know-your-silhouette-panel[data-index="' + index + '"]');

        if (!nextPanel || currentPanel === nextPanel) return;

        isAnimating = true;

        tabs.forEach(function (t) {
          t.classList.remove('is-active');
        });
        this.classList.add('is-active');

        comparisonCells.forEach(function (cell) {
          if (cell.getAttribute('data-index') === index) {
            cell.classList.add('is-active');
          } else {
            cell.classList.remove('is-active');
          }
        });

        if (currentPanel) {
          currentPanel.classList.remove('is-active');
          currentPanel.classList.add('is-fading-out');

          currentPanel.addEventListener('transitionend', function handler() {
            currentPanel.removeEventListener('transitionend', handler);
            currentPanel.classList.remove('is-fading-out');

            nextPanel.classList.add('is-visible');
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                nextPanel.classList.remove('is-visible');
                nextPanel.classList.add('is-active');
                isAnimating = false;
              });
            });
          });
        } else {
          nextPanel.classList.add('is-visible');
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              nextPanel.classList.remove('is-visible');
              nextPanel.classList.add('is-active');
              isAnimating = false;
            });
          });
        }
      });
    });
  });
});
